import React from "react";
import ImageArea from "../../Common/ImageArea";
import { Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import { CommonModalStyle } from "../../../style/basic/commonControls";
import { ModalStyles } from "../../Common/styles";
import { languageService } from "../../../Language/language.service";
import { MyButton } from "../../Common/Forms/formsMiscItems";
import { themeService } from "../../../theme/service/activeTheme.service";

export const Notes = (props) => {
  let showNotesModal = props.showNotesModal;
  let dataForNotes = props.dataForNotes;
  return (
    <Modal contentClassName={themeService({ retro: "retroModal" })} isOpen={showNotesModal} style={{ maxWidth: "40vw" }}>
      <ModalHeader style={(ModalStyles.modalTitleStyle, themeService(CommonModalStyle.header))}>
        {dataForNotes && dataForNotes.mrNumber}
      </ModalHeader>

      <ModalBody style={(ModalStyles.footerButtonsContainer, themeService(CommonModalStyle.body))}>
        {dataForNotes && (
          <div
            style={{
              backgroundColor: "white",
              padding: "5px 12px 5px 12px",
              maxHeight: "50vh",
            }}
          >
            <strong>{languageService("Information")}:</strong>
            <p>{dataForNotes.issue && dataForNotes.issue.voiceNotes ? dataForNotes.issue.voiceNotes : ""}</p>
          </div>
        )}

        <br></br>
        {dataForNotes && dataForNotes.issue.imgList && dataForNotes.issue.imgList.length > 0 && (
          <div
            style={{
              backgroundColor: "white",
              padding: "5px 12px 5px 12px",
              maxHeight: "50vh",
            }}
          >
            <Row>
              <Col md="12">
                <ImageArea path="applicationresources" imagesList={dataForNotes.issue.imgList} imageHeight={"100px"} />
              </Col>
            </Row>
          </div>
        )}
      </ModalBody>

      <ModalFooter style={(ModalStyles.footerButtonsContainer, themeService(CommonModalStyle.footer))}>
        <MyButton
          bsStyle="warning"
          onClick={() => {
            props.handleNotesClose();
          }}
        >
          {languageService("Close")}
        </MyButton>
      </ModalFooter>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/Maintenance/Notes/NotesView.jsx